import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  IGetLastVersionCaminhaoInfoByEntradaOrAgendamentoOrPlaca,
  IGetLastVersionCaminhaoInfoByEntradaOrAgendamentoOrPlacaResponse
} from 'src/app/services/CaminhaoService/caminhao.model';
import { CaminhaoService } from 'src/app/services/CaminhaoService/caminhao.service';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { EntradaGateService } from 'src/app/services/EntradaGateService/entradaGate.service';
import { ICreateMovimentacaoPaleteSaidaBody } from 'src/app/services/PaleteService/palete.model';
import { PaleteService } from 'src/app/services/PaleteService/palete.service';
import Swal from 'sweetalert2';
import { Location } from '@angular/common';
import { CarretaService } from 'src/app/services/CarretaService/carreta.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';

interface IOptions {
  name: string;
  value: string | number;
}

@Component({
  selector: 'app-cadastro-saida-estacionamento-tpg',
  templateUrl: './cadastro-saida-estacionamento-tpg.component.html',
  styleUrls: ['./cadastro-saida-estacionamento-tpg.component.scss']
})
export class CadastroSaidaEstacionamentoTpgComponent implements OnInit {
  form: FormGroup;
  id = localStorage.getItem('id');
  isViewing: boolean = false;
  isLoading: boolean = false;
  carretasSelecionadas: string = 'Selecione';
  carretasMovmSelecionadas: string = 'Selecione';
  guid = generateUUID();

  carretaOptions: IOptions[] = [];
  carretaMovmOptions: IOptions[] = [];

  itemOptions: IOptions[] = [
    {
      name: 'Palete',
      value: 1
    },
    {
      name: 'Lona',
      value: 2
    },
    {
      name: 'Grade Baixa',
      value: 3
    },
    {
      name: 'Grade Alta',
      value: 4
    },
    {
      name: 'Tampa',
      value: 5
    }
  ];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private paleteService: PaleteService,
    private caminhaoService: CaminhaoService,
    private carretaService: CarretaService,
    public swalAlert: SwalAlertService,
    private cd: ChangeDetectorRef
  ) {
    this.form = this.initForm();
  }

  ngOnInit(): void {
    this.activateRoute();
  }

  initForm(): FormGroup {
    return this.fb.group({
      TX_OBSV_MOVM_PLTE: [null],
      NU_ITEM_MOVM: [null, Validators.required],
      FK_FUNC_OPER: [this.id, Validators.required],
      FK_AGND: [null],
      TX_PLCA_CRRT: [null, [Validators.required, Validators.minLength(7)]],
      TX_PLCA_CAVA: [null, [Validators.required, Validators.minLength(7)]],
      TX_PLCA_CAVA_MOVM: [null],
      NM_MTRT: [null],
      QT_MOVM_PLTE: [null, Validators.required],
      FK_CRRT_1: [null, Validators.required],
      FK_CRRT_2: [null],
      FK_CRRT_3: [null]
    });
  }

  postPalete(): void {
    this.isLoading = true;
    const payload = this.createPayload();
    this.paleteService
      .CreateMovimentacaoPaleteSaida(payload, this.guid)
      .subscribe({
        next: res => {
          this.isLoading = false;
          this.router.navigate(['listagem/estacionamento-tpg']);
        },
        error: err => {
          this.isLoading = false;
        }
      });
  }

  getAgendamentoOrCavalo(): void {
    const invalidValue = ['', 0, undefined, null];
    const payload: IGetLastVersionCaminhaoInfoByEntradaOrAgendamentoOrPlaca = {
      FK_AGND: null,
      TX_PLCA_CAVA: null
    };
    let placaCavalo = this.form.controls['TX_PLCA_CAVA'].value;
    let agendamentoId = Number(this.form.controls['FK_AGND'].value);

    payload.FK_AGND = agendamentoId;

    if (!invalidValue.includes(placaCavalo))
      payload.TX_PLCA_CAVA = placaCavalo.length > 7 ? placaCavalo : null;

    this.isLoading = true;

    if (
      !invalidValue.includes(placaCavalo) ||
      !invalidValue.includes(agendamentoId)
    ) {
      this.caminhaoService
        .GetLastVersionCaminhaoInfoByEntradaOrAgendamentoOrPlaca(
          null,
          agendamentoId,
          placaCavalo
        )
        .subscribe({
          next: res => {
            const data = res;
            if (!data) {
              this.swalAlert.showAlert(
                'Atenção!',
                'Nenhuma informação encontrada para o agendamento informado!',
                'warning'
              );
              this.isLoading = false;
              return;
            }
            this.form.controls['TX_PLCA_CAVA'].setValue(data.TX_PLCA_CAVA);
            if (!this.isViewing) {
              this.form.controls['NM_MTRT'].setValue(
                data.NM_USUA_MTRT ?? data.NM_MTRT
              );
            }
            this.carretaOptions = [];
            this.setCarretaOptions(data, false);
            this.isLoading = false;
          },
          error: err => {
            this.isLoading = false;
          }
        });
    } else {
      this.isLoading = false;
      this.clearForms();
    }
  }

  getAgendamentoOrCavaloMovm(): void {
    const invalidValue = ['', 0, undefined, null];
    const payload: IGetLastVersionCaminhaoInfoByEntradaOrAgendamentoOrPlaca = {
      FK_AGND: null,
      TX_PLCA_CAVA: null
    };
    let placaCavalo = this.form.controls['TX_PLCA_CAVA_MOVM'].value;
    let agendamentoId = null;

    payload.FK_AGND = agendamentoId;

    if (!invalidValue.includes(placaCavalo))
      payload.TX_PLCA_CAVA = placaCavalo.length > 7 ? placaCavalo : null;

    this.isLoading = true;

    if (
      !invalidValue.includes(placaCavalo) ||
      !invalidValue.includes(agendamentoId)
    ) {
      this.caminhaoService
        .GetLastVersionCaminhaoInfoByEntradaOrAgendamentoOrPlaca(
          null,
          agendamentoId,
          placaCavalo
        )
        .subscribe({
          next: res => {
            const data = res;
            if (!data) {
              this.swalAlert.showAlert(
                'Atenção!',
                'Nenhuma informação encontrada para o agendamento informado!',
                'warning'
              );
              this.isLoading = false;
              return;
            }
            this.carretaMovmOptions = [];
            this.setCarretaOptions(data, true);
            this.isLoading = false;
          },
          error: err => {
            this.isLoading = false;
          }
        });
    } else {
      this.isLoading = false;
      this.clearForms();
    }
  }

  getMovimentacaoPaleteByPlacaCarreta(): void {
    const placaCarreta = this.form.controls['TX_PLCA_CRRT'].value;
    this.form.controls['QT_MOVM_PLTE'].reset();
    this.form.controls['NU_ITEM_MOVM'].reset();
    this.isLoading = true;
    this.paleteService
      .GetMovimentacaoPaleteByPlacaCarreta(placaCarreta)
      .subscribe({
        next: res => {
          const data = res;
          if (!data) {
            this.swalAlert.showAlert(
              'Atenção!',
              'Nenhuma movimentação encontrada para a placa informada!',
              'warning'
            );
            this.isLoading = false;
            return;
          }
          this.form.controls['QT_MOVM_PLTE'].setValue(data.QT_MOVM_PLTE);
          this.form.controls['NU_ITEM_MOVM'].setValue(data.NU_ITEM_MOVM);
          this.isLoading = false;
        },
        error: err => {
          this.form.controls['QT_MOVM_PLTE'].reset();
          this.form.controls['NU_ITEM_MOVM'].reset();
          this.isLoading = false;
        }
      });
  }

  setCarretaOptions(
    data: IGetLastVersionCaminhaoInfoByEntradaOrAgendamentoOrPlacaResponse,
    movm?: boolean
  ): void {
    if (data.FK_CRRT_1 && data.TX_PLCA_CRRT1 && movm) {
      this.carretaMovmOptions.push({
        name: data.TX_PLCA_CRRT1,
        value: data.FK_CRRT_1
      });
    }
    if (data.FK_CRRT_2 && data.TX_PLCA_CRRT2 && movm) {
      this.carretaMovmOptions.push({
        name: data.TX_PLCA_CRRT2,
        value: data.FK_CRRT_2
      });
    }
    if (data.FK_CRRT_3 && data.TX_PLCA_CRRT3 && movm) {
      this.carretaMovmOptions.push({
        name: data.TX_PLCA_CRRT3,
        value: data.FK_CRRT_3
      });
    }

    if (data.FK_CRRT_1 && data.TX_PLCA_CRRT1 && !movm) {
      this.carretaOptions.push({
        name: data.TX_PLCA_CRRT1,
        value: data.FK_CRRT_1
      });
    }
    if (data.FK_CRRT_2 && data.TX_PLCA_CRRT2 && !movm) {
      this.carretaOptions.push({
        name: data.TX_PLCA_CRRT2,
        value: data.FK_CRRT_2
      });
    }
    if (data.FK_CRRT_3 && data.TX_PLCA_CRRT3 && !movm) {
      this.carretaOptions.push({
        name: data.TX_PLCA_CRRT3,
        value: data.FK_CRRT_3
      });
    }
  }

  createPayload(): ICreateMovimentacaoPaleteSaidaBody {
    return {
      TX_OBSV_MOVM_PLTE: this.form.controls['TX_OBSV_MOVM_PLTE'].value,
      FK_AGND: this.form.controls['FK_AGND'].value,
      FK_FUNC_OPER: Number(this.form.controls['FK_FUNC_OPER'].value),
      TX_PLCA_CRRT: String(
        this.form.controls['TX_PLCA_CRRT'].value
      ).toUpperCase(),
      TX_PLCA_CAVA: String(
        this.form.controls['TX_PLCA_CAVA'].value
      ).toUpperCase(),
      FK_CRRT_1: this.form.controls['FK_CRRT_1'].value,
      FK_CRRT_2: this.form.controls['FK_CRRT_2'].value,
      FK_CRRT_3: this.form.controls['FK_CRRT_3'].value
    };
  }

  setForms() {
    this.clearForms();
    this.getAgendamentoOrCavalo();
  }

  clearForms(): void {
    const placaCavalo = this.form.controls['TX_PLCA_CAVA'].value;
    const agendamento = this.form.controls['FK_AGND'].value;

    if (placaCavalo == '' || agendamento == '') {
      this.form.reset();
      this.initForm();
    }
  }

  activateRoute(): void {
    this.form.controls['NU_ITEM_MOVM'].disable();
    this.form.controls['QT_MOVM_PLTE'].disable();
    this.isLoading = true;
    this.route.queryParams.subscribe(params => {
      if (params['isViewing'] === 'true') {
        this.isViewing = true;
        this.form.controls['FK_AGND'].setValue(params['FK_AGND']);
        this.form.controls['TX_PLCA_CAVA'].setValue(params['TX_PLCA_CAVA']);
        this.carretasSelecionadas = params['TX_PLCA_CRRT'];
        this.form.controls['TX_OBSV_MOVM_PLTE'].setValue(
          params['TX_OBSV_MOVM_PLTE']
        );
        this.form.controls['NM_MTRT'].setValue(params['NM_MTRT']);

        this.getCarretaByMovimentacaoEntradaPalete(
          Number(params['FK_MOVM_PLTE'])
        );

        this.form.disable();
      }
      this.isLoading = false;
    });
  }

  getCarretaByMovimentacaoEntradaPalete(idMovimentacao: number) {
    this.paleteService.GetMovimentacaoPaleteById(idMovimentacao).subscribe({
      next: responseMovimentacaoPalete => {
        this.form.controls['QT_MOVM_PLTE'].setValue(
          responseMovimentacaoPalete.QT_MOVM_PLTE
        );
        this.form.controls['NU_ITEM_MOVM'].setValue(
          responseMovimentacaoPalete.NU_ITEM_MOVM
        );

        let placasRetas: string = '';

        let idCarretas: number[] = [
          responseMovimentacaoPalete.FK_CRRT_1,
          responseMovimentacaoPalete.FK_CRRT_2,
          responseMovimentacaoPalete.FK_CRRT_3
        ];

        idCarretas.forEach(idCarreta => {
          if (idCarreta)
            this.carretaService.GetCarretaById(idCarreta).subscribe({
              next: responseCarreta => {
                if (responseCarreta.TX_PLCA_CRRT)
                  this.form.controls['TX_PLCA_CRRT'].setValue(
                    responseCarreta.TX_PLCA_CRRT
                  );
              }
            });
        });
      }
    });
  }

  onItemChange(event: number): void {
    this.form.controls['NU_ITEM_MOVM'].setValue(event);
  }

  onCarretaChange(event: any): void {
    if (!event.length) {
      this.carretasSelecionadas = 'Selecione';
      return;
    }

    this.form.controls['FK_CRRT_1'].reset();
    this.form.controls['FK_CRRT_2'].reset();
    this.form.controls['FK_CRRT_3'].reset();

    const carretasSelecionadas = this.carretaOptions
      .filter(x => event.includes(x.value))
      .map(x => x.name)
      .join(' | ');
    this.carretasSelecionadas = carretasSelecionadas;

    switch (event.length) {
      case 1:
        this.form.controls['FK_CRRT_1'].setValue(event[0]);
        this.form.controls['FK_CRRT_2'].setValue(null);
        this.form.controls['FK_CRRT_3'].setValue(null);
        break;
      case 2:
        this.form.controls['FK_CRRT_1'].setValue(event[0]);
        this.form.controls['FK_CRRT_2'].setValue(event[1]);
        this.form.controls['FK_CRRT_3'].setValue(null);
        break;
      case 3:
        this.form.controls['FK_CRRT_1'].setValue(event[0]);
        this.form.controls['FK_CRRT_2'].setValue(event[1]);
        this.form.controls['FK_CRRT_3'].setValue(event[2]);
        break;
      default:
        break;
    }
  }

  onCarretaMovmChange(event: any): void {
    if (!event.length) {
      this.carretasMovmSelecionadas = 'Selecione';
      return;
    }

    const carretasMovmSelecionadas = this.carretaMovmOptions
      .filter(x => event.includes(x.value))
      .map(x => x.name)
      .join(' | ');
    this.carretasMovmSelecionadas = carretasMovmSelecionadas;

    switch (event.length) {
      case 1 || 2 || 3:
        this.getMovimentacaoPaleteByPlacaCarreta();
        break;
      default:
        break;
    }
  }
}
